import { c as _c } from "react/compiler-runtime";
import React from 'react';
export function Box(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <div className="flex flex-col gap-4 rounded-2xl bg-white p-6 lg:rounded-3xl">{children}</div>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}